module.exports = __webpack_public_path__ + "img/server3.97ff0bc0.svg";